import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ContactEmailRequest {
  fromEmail: string;
  fromName: string;
  topic: string;
  message: string;
}

export interface EmailResponse {
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private readonly apiUrl = `${environment.apiUrl}/email`;

  constructor(private http: HttpClient) {}

  /**
   * Send a contact form email via the backend API
   */
  sendContactEmail(request: ContactEmailRequest): Observable<EmailResponse> {
    return this.http.post<EmailResponse>(`${this.apiUrl}/contact`, request);
  }
}
